import TinyDateField from './styled';

export default TinyDateField;
